// extracted by mini-css-extract-plugin
export default {"root":"U2Ufp","header":"EjxIL","tabs":"phPiT"};